import { api } from "../../api";
import { useMemo } from "react";
import LocationsTable from "./LocationsTable";
import { locationsConfig as config } from "./locationsConfig.ts";
import { LocationEntry } from "../../types/shared.ts";
import { locationsFromExternalList } from "./converts.ts";
import { useDataGridQuery, useUrlState } from "../../hooks/useUrlState.ts";
import { useDebouncedValue } from "../../hooks/useDebouncedValue.tsx";
import LocationsToolbar from "./LocationsToolbar.tsx";
import { TableDialogs } from "../../components/TableDialogs.tsx";
import { ViewProvider } from "../../contexts/ViewContext.tsx";
import { LOCATIONS_DEFAULTS } from "../../helpers/defaultUrl.ts";
import { ConfirmDialog } from "primereact/confirmdialog";

const columns = config.columns;

export default function LocationsPage() {
  const { globalFilterValue, setGlobalFilterValue } = useUrlState();
  const debouncedSearchValue = useDebouncedValue(globalFilterValue, 300);

  const { page, limit, sort, order, onPageChange, onSortChange } =
    useDataGridQuery({
      page: LOCATIONS_DEFAULTS.page,
      limit: LOCATIONS_DEFAULTS.limit,
      sort: LOCATIONS_DEFAULTS.sort,
      order: LOCATIONS_DEFAULTS.order,
    });

  //sorting
  const orderByField = useMemo(() => {
    const base = sort ?? LOCATIONS_DEFAULTS.sort;
    const direction = order === -1 ? "-" : "";
    return `${direction}${base}`;
  }, [sort, order]);

  const { data: rawData, isLoading } =
    api.endpoints.listLocationsApiLocationsGet.useQuery({
      orderBy: `${orderByField},address,-created_at`,
      limit: limit,
      offset: page * limit,
      search: debouncedSearchValue || undefined,
    });

  const data: LocationEntry[] = useMemo(() => {
    if (!rawData) {
      return [];
    }
    return rawData.items.map(locationsFromExternalList);
  }, [rawData]);

  return (
    <ViewProvider view={config.view}>
      <TableDialogs />
      <ConfirmDialog />
      <LocationsToolbar
        config={config}
        globalFilterValue={globalFilterValue}
        setGlobalFilterValue={setGlobalFilterValue}
      />
      <LocationsTable
        data={data}
        columns={columns}
        page={page}
        rowsPerPage={limit}
        onPage={(e) => onPageChange(e.page ?? 0, e.rows ?? limit)}
        totalRecords={rawData?.total || 0}
        sortField={sort}
        sortOrder={order}
        onSort={(e) => onSortChange(e.sortField, e.sortOrder ?? 1)}
        isLoading={isLoading}
      />
    </ViewProvider>
  );
}
